module.exports = __webpack_public_path__ + "img/logo-dark.c38ee4dc.png";